import { render, staticRenderFns } from "./hotelListScreen.vue?vue&type=template&id=0d8c8f28&scoped=true&"
import script from "./hotelListScreen.vue?vue&type=script&lang=js&"
export * from "./hotelListScreen.vue?vue&type=script&lang=js&"
import style0 from "./hotelListScreen.vue?vue&type=style&index=0&id=0d8c8f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8c8f28",
  null
  
)

export default component.exports